export const removeElementByIndex = (array, index) => {
  const arrayCopy = [...array];
  return arrayCopy.splice(index, 1);
};

export const removeElementById = (array, id) => array.filter((item) => item.id !== id);
